import { render, staticRenderFns } from "./FileTable.vue?vue&type=template&id=59f39822&scoped=true&"
import script from "./FileTable.vue?vue&type=script&lang=js&"
export * from "./FileTable.vue?vue&type=script&lang=js&"
import style0 from "./FileTable.vue?vue&type=style&index=0&id=59f39822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f39822",
  null
  
)

export default component.exports